import type { Dispatch, SetStateAction } from "react";
import { createContext, useContext } from "react";

export type CompareContextType = {
    grades: (string | undefined)[];
    setGrades: Dispatch<SetStateAction<(string | undefined)[]>>;
    openedCollapses: string[];
    setOpenedCollapses: Dispatch<SetStateAction<string[]>>;
};

export const CompareContext = createContext<CompareContextType>({
    grades: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setGrades: () => {},
    openedCollapses: [],
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setOpenedCollapses: () => {},
});

export const useCompareContext = (): CompareContextType => useContext(CompareContext);
